import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ErrorHandler from 'common/error/components/error-handler';
import styled from 'styled-components';
import { useParams } from 'react-router';
import { decodeUrlParams } from 'utils/helpers';
import SearchRelationsComponent from '../../components/relations/search-relations-results';
import {
  searchRelations as searchAction,
  clearSearchResult as clearSearchAction,
} from '../search-actions';

const StyledDiv = styled.div`
  margin: 0 -20px !important;
  background-color: white;
  height: calc(100vh - 59px);
`;

const SearchRelations = ({
  search,
  clearSearchResults,
  results,
  isLoading,
  error,
}) => {
  const params = useParams();

  useEffect(() => () => {
    clearSearchResults();
    if (localStorage.getItem('searchFilters')) {
      localStorage.removeItem('searchFilters');
    }
  }, []);

  useEffect(() => {
    if (params.relationId) {
      const urlParams = decodeUrlParams(params);
      search({ id: urlParams.relationId });
    }
  }, [params.relationId]);

  return (
    <StyledDiv>
      <ErrorHandler type='notification' error={error} />
      <SearchRelationsComponent
        results={results}
        isLoading={isLoading}
      />
    </StyledDiv>
  );
};

SearchRelations.propTypes = {
  search: PropTypes.func,
  clearSearchResults: PropTypes.func,
  results: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
};


const mapStateToProps = state => ({
  searchValue: state.search.searchValue,
  results: state.search.relations.results,
  isLoading: state.search.relations.isLoading,
  error: state.search.relations.error,
});

const mapDispatchToProps = {
  search: searchAction,
  clearSearchResults: clearSearchAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchRelations);
